import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { SortOrderRequestBody, SortOrderResponseBody } from "./types";

export class SortOrderSearchAPI extends BaseAPI<
  SortOrderRequestBody,
  SortOrderResponseBody
> {
  protected route = ApiRoutes.campaign.sort;
  protected method = RequestMethod.GET;
}
